__turbopack_context__.v({
  "avatarFallback": "AuthorDetail-module__ltqOCG__avatarFallback",
  "avatarWrap": "AuthorDetail-module__ltqOCG__avatarWrap",
  "backToBlog": "AuthorDetail-module__ltqOCG__backToBlog",
  "bio": "AuthorDetail-module__ltqOCG__bio",
  "heroInner": "AuthorDetail-module__ltqOCG__heroInner",
  "jobTitle": "AuthorDetail-module__ltqOCG__jobTitle",
  "postsHeading": "AuthorDetail-module__ltqOCG__postsHeading",
  "socialLink": "AuthorDetail-module__ltqOCG__socialLink",
  "socials": "AuthorDetail-module__ltqOCG__socials",
});
